import { ReducerAction } from '@keplerco/core';
import { CompanySkillListResponse } from '../../../models/overmind/company-entity';
import { SearchSkillsRequest } from '../../../models/overmind/search-params';

// state
interface YourCareerSkillsState {
  request: SearchSkillsRequest | undefined;
  data: CompanySkillListResponse | undefined;
}

export const initialState: YourCareerSkillsState = {
  request: undefined,
  data: undefined,
};

// actions
export enum YourCareerSkillsActionTypes {
  SetRequest,
  SetData,
}

type YourCareerSkillsActions = ReducerAction<YourCareerSkillsActionTypes.SetRequest, { payload: SearchSkillsRequest }> | ReducerAction<YourCareerSkillsActionTypes.SetData, { payload: CompanySkillListResponse | undefined }>;

// reducer
export function reducer(state: YourCareerSkillsState, action: YourCareerSkillsActions): YourCareerSkillsState {
  if (action.type === YourCareerSkillsActionTypes.SetRequest) {
    return { ...state, request: action.payload };
  }

  if (action.type === YourCareerSkillsActionTypes.SetData) {
    return { ...state, data: action.payload };
  }

  return state;
}
